import React, {FC, memo} from "react";
import {Formik} from "formik";
import {TableType} from "./PaymentsListColumns";
import {ModifyScheduledPaymentInput, PaymentProvider} from "../../generated/graphql";
import EditScheduledPaymentForm from "./EditScheduledPaymentForm";

type EditScheduledPaymentProps = {
    record?: TableType;
    setEditPaymentOpen: (value: boolean) => void;
    refetch?: () => void;
};

const EditScheduledPayment: FC<EditScheduledPaymentProps> = ({
    record,
    setEditPaymentOpen,
    refetch,
}) => {
    if (!record) {
        return null;
    }

    // Mollie-Lock (Plan 2026-05-20): Eine ueber Mollie bereits bezahlte Rate ist
    // eine Tatsache — Betrag und Zahldatum/Unbezahlt werden im Form gesperrt.
    const isMolliePaid =
        record.paymentProvider === PaymentProvider.Mollie && record.paymentDone !== null;

    return (
        <div>
            <Formik<ModifyScheduledPaymentInput>
                initialValues={{
                    id: record.id,
                    paymentAmount: record.paymentAmount,
                    paymentDue: record.paymentDue,
                    paymentDone: record.paymentDone,
                    paymentMethodId: record.paymentMethodId,
                    sepaClearance: Boolean(record.sepaClearance),
                    note: record.note,
                    title: record.title,
                    type: record.type,
                }}
                onSubmit={(values, {setSubmitting}) => {
                    setSubmitting(false);
                }}
                enableReinitialize={true}
                render={(formikProps) => {
                    return (
                        <EditScheduledPaymentForm
                            formikProps={formikProps}
                            setEditPaymentOpen={setEditPaymentOpen}
                            bookingId={record.booking.id}
                            refetch={refetch}
                            isMolliePaid={isMolliePaid}
                            hasInvoice={Boolean(record.invoice)}
                        />
                    );
                }}
            />
        </div>
    );
};

export default memo(EditScheduledPayment);
